import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import NinjaVanRateCard from '@/components/v2/NinjaVanRateCard.vue';
import PandaGoRateCard from '@/components/v2/PandaGoRateCard.vue';
import JntExpressRateCard from '@/components/v2/JntExpressRateCard.vue';
let RateCard = class RateCard extends Mixins() {
    constructor() {
        super(...arguments);
        this.toggleNinjaVan = false;
        this.togglePandaGo = false;
        this.toggleJntExpress = false;
    }
    toggleForm(shippingName) {
        if (shippingName === 'Standard Delivery by Ninja Van') {
            this.toggleNinjaVan = true;
        }
        else if (shippingName === 'PandaGo') {
            this.togglePandaGo = true;
        }
        else if (shippingName === 'J&T Express') {
            this.toggleJntExpress = true;
        }
    }
    closeForm() {
        this.toggleNinjaVan = false;
        this.togglePandaGo = false;
        this.toggleJntExpress = false;
    }
};
RateCard = __decorate([
    Component({
        components: {
            NinjaVanRateCard,
            PandaGoRateCard,
            JntExpressRateCard,
        },
    })
], RateCard);
export default RateCard;
